import { render, staticRenderFns } from "./EventsCatalog.vue?vue&type=template&id=74e34aec"
import script from "./EventsCatalog.vue?vue&type=script&lang=js"
export * from "./EventsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports